import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { provideConfig } from '@spartacus/core';
import { GenericLinkModule, MediaModule } from '@spartacus/storefront';

import { DpBannerComponent } from './banner.component';


@NgModule({
  declarations: [DpBannerComponent],
  exports:[DpBannerComponent],
  imports: [GenericLinkModule, AsyncPipe, MediaModule],
  providers:[provideConfig({
    cmsComponents: {

      SimpleBannerComponent: {
        component: DpBannerComponent,
      },
      SimpleResponsiveBannerComponent: {
        component: DpBannerComponent,
      },
      BannerComponent: {
        component: DpBannerComponent,
      },
    }
  })]
})
export class DpBannerModule { }
